import { useRef, useEffect } from 'react';

/**
 * Custom hook for PersonalisationHelperModal logic and className selection.
 *
 * @param {Object} props - Hook props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {function} props.onClose - Callback for closing the modal
 * @returns {{ dialogRef: React.RefObject<HTMLDialogElement | null>, handleClose: () => void }}
 */
export function useViewModel({ isOpen, onClose }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      dialogRef.current?.showModal();
      setTimeout(() => {
        dialogRef.current?.setAttribute('data-open', 'true');
      }, 10);
    } else {
      dialogRef.current?.setAttribute('data-open', 'false');
      setTimeout(() => {
        dialogRef.current?.close();
      }, 400);
    }
  }, [isOpen]);

  /**
   * Handles closing the modal dialog.
   * @returns {void}
   */
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return {
    dialogRef,
    handleClose
  };
}
